import { Box, Icon, IconButton, Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CompactTable } from "../../_components/table/compact.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { formService } from "../../_services/form.service";
import { officialLicenseService } from "../../_services/officialLicense.service";
import { UserProfileOfficialLicenseManageDrawer } from "./userProfile-officialLicenseManageDrawer";


export function UserProfileOfficialLicenseList(params: {}) {

    const { userId } = useParams<{ userId: string }>();
    let navigate = useNavigate();

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 100, page: 0, order: 'desc', orderBy: '' });

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {
        setLoading(true);
        return officialLicenseService
            .getAll({ ...filter, userId: userId || '' })
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function generateLicense(id: number) {
        navigate("" + id)
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'licenseNumber',
                header: 'Licence Number',
                maxSize: 80
            },
            {
                accessorKey: 'licenseName',
                header: ' Licence'
            },
            {
                accessorKey: 'licenseTypeName',
                header: ' Licence Type'
            },
            {
                accessorKey: 'expiryDateStr',
                header: 'Expiry Date',
                maxSize: 80,
            }

        ],
        [],
    );

    function CreateForm(type: FormTemplateTypeEnum) {

        return formService.createByType(type, userId)
            .then(
                data => {
                    navigate("../Forms/" + data)
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            {accountService.isAdmin &&
                <PageHeader
                    pageName="Official Licence"
                    actionType="create"
                    buttonName={`New Licence`}
                    onClick={() => { navigate("CreateLicense") }}
                />
            }

            {!accountService.isAdmin &&
                <PageHeader
                    pageName="Official Licence"
                    actionType="create"
                />
            }


            <Paper>

                <CompactTable
                    columns={columns}
                    data={data.items}
                    enableGrouping={true}
                    isLoading={isLoading}
                    initialState={{
                        grouping: ['expiryDateStr', 'licenseNumber'],
                        density: 'compact',
                        expanded: true
                    }}
                    renderRowActions={({ cell, row, table }: { cell: any, row: any, table: any }) =>
                        accountService.isAdmin ? <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                            <IconButton
                                color="primary"
                                onClick={() => { navigate("EditLicense/" + (row.original as any).id) }}
                            >
                                <Icon>edit</Icon>
                            </IconButton>
                        </Box> : <></>
                    }
                />
            </Paper>

            <Routes>
                <Route path="/EditLicense/:licenseId" element={<UserProfileOfficialLicenseManageDrawer onSave={() => { navigate("."); fetchData(); navigate(0); }} onClose={() => { navigate("."); }} />} />
                <Route path="/CreateLicense" element={<UserProfileOfficialLicenseManageDrawer onSave={() => { navigate("."); fetchData(); navigate(0); }} onClose={() => { navigate("."); }} />} />
            </Routes>
        </>
    );
}